module.exports = __webpack_public_path__ + "6ca871b57a2749a8674a55a7be58d7ad.pdf";